import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { Keyboard, KeyboardResize } from '@capacitor/keyboard';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { Network } from '@capacitor/network';

export const isNativePlatform = () => {
  return Capacitor.isNativePlatform();
};

export const initializeMobileApp = async () => {
  if (!isNativePlatform()) return;

  try {
    // Configure status bar
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: '#f97316' });

    // Hide splash screen
    await SplashScreen.hide();

    // Configure keyboard
    await Keyboard.setResizeMode({ mode: KeyboardResize.Body });
    await Keyboard.setScroll({ isDisabled: false });

    // Set up app state listeners
    App.addListener('appStateChange', ({ isActive }) => {
      console.log('App state changed. Is active?', isActive);
    });

    App.addListener('backButton', ({ canGoBack }) => {
      if (!canGoBack) {
        App.exitApp();
      } else {
        window.history.back();
      }
    });

    // Set up network status listener
    Network.addListener('networkStatusChange', status => {
      console.log('Network status changed', status);
    });

  } catch (error) {
    console.error('Error initializing mobile app:', error);
  }
};

export const triggerHapticFeedback = async (style: ImpactStyle = ImpactStyle.Medium) => {
  if (!isNativePlatform()) return;
  
  try {
    await Haptics.impact({ style });
  } catch (error) {
    console.error('Error triggering haptic feedback:', error);
  }
};

export const getNetworkStatus = async () => {
  if (!isNativePlatform()) return { connected: true, connectionType: 'wifi' };
  
  try {
    return await Network.getStatus();
  } catch (error) {
    console.error('Error getting network status:', error);
    return { connected: false, connectionType: 'unknown' };
  }
};

export const handleAppUrl = () => {
  if (!isNativePlatform()) return;

  try {
    App.addListener('appUrlOpen', ({ url }) => {
      if (url) {
        console.log('App opened with URL:', url);
        // TODO: route based on the URL if needed
      }
    });
  } catch (error) {
    console.error('Error handling app URL:', error);
  }
};
